import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { makeStyles, Label } from '@fluentui/react-components';
import { HelpButton } from '@bingads-webui-react/help-popup';

const useStyles = makeStyles({
  dateManagementSelector: {
    marginBottom: '16px',
  },
  stackStyles: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    width: 'auto',
    height: 'auto',
    boxSizing: 'border-box',
    '> *': {
      textOverflow: 'ellipsis',
    },
    '> :not(:first-child)': {
      marginTop: '0px',
    },
    '> *:not(.ms-StackItem)': {
      flexShrink: 1,
    },
  },
  stackItem: {
    height: 'auto',
    width: 'auto',
    flexShrink: 1,
  },
});

export const InfoLabel = ({ label, infoTopic }) => {
  const i18n = useContext(I18nContext);
  const classes = useStyles();

  return (
    <div className={classes.stackStyles} >
      <Label size="medium" weight="semibold" className={classes.stackItem}>
        {i18n.getString(label)}
      </Label>
      {infoTopic &&
        <HelpButton
          className={classes.stackItem}
          topic={infoTopic}
          aria-label={i18n.getString(_TL_('Click to learn more about {{item}}'), { item: infoTopic })}
        />
      }
    </div>
  );
};

InfoLabel.propTypes = {
  label: PropTypes.string.isRequired,
  infoTopic: PropTypes.string,
};

InfoLabel.defaultProps = {
  infoTopic: null,
};
